import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M0 1H16" stroke="#DF692B" strokeWidth="1.375" />
      <path d="M0 6.5H16" stroke="#DF692B" strokeWidth="1.375" />
      <path d="M0 12H16" stroke="#DF692B" strokeWidth="1.375" />
    </Svg>
  );
};

export default Icon;
